export type Stage = "alpha" | "beta" | "gamma" | "prod";

export const STAGES: Stage[] = ["alpha", "beta", "gamma", "prod"];

export const ROOT_DOMAIN = "horizon.aws.dev";
export const ROOT_PATH = "/profile";

export const BASE_DOMAINS = {
  dev: {
    horizon: `.${ROOT_DOMAIN}`,
    platformTeamCF: `.awsmigration.marketing-webops.aws.dev`,
    auth: ".auth-builderprofile.aws.dev",
    bpGlobal: "global-gamma-api-v2.builderprofile.aws.dev",
    bpAppId: "horizon-",
  },
  prod: {
    horizon: "aws.amazon.com",
    auth: "auth.aws.amazon.com",
    bpGlobal: "global-api-v2.builderprofile.aws.dev",
    bpAppId: "horizon-",
    platformTeamCF: "aws.com",
  },
};

export const SERVER_ACTION_ALLOWED_ORIGINS = [
  `${process.env.STAGE}${BASE_DOMAINS.dev.horizon}`,
  `internal.${process.env.STAGE}${BASE_DOMAINS.dev.horizon}`,
  BASE_DOMAINS.prod.horizon,
  ROOT_DOMAIN,
  `internal.${ROOT_DOMAIN}`,
  ...(process.env.STAGE === "dev" ? [`localhost:3000`] : []),
  `${process.env.STAGE}${BASE_DOMAINS.dev.platformTeamCF}`,
  `www.${process.env.STAGE}${BASE_DOMAINS.dev.platformTeamCF}`,
  `${BASE_DOMAINS.prod.platformTeamCF}`,
  `www.${BASE_DOMAINS.prod.platformTeamCF}`,
];
